import { KeyboardArrowLeft } from "@mui/icons-material";
import { Box, Grid, Rating, Typography } from "@mui/material";
import MReviewCard from "features/searchStore/components/MReviewCard";
import ReviewCard from "features/searchStore/components/ReviewCard";
import { reviewList } from "features/searchStore/mockupApi";
import { selectStoreDetail } from "features/searchStore/saga/searchStoreSlice";
import { useAppSelector } from "redux/hooks";

function MReviewSection({ handleClose }: { handleClose: () => void }) {
  const storeData = useAppSelector(selectStoreDetail);
  return (
    <Box display="flex" flexDirection="column">
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="relative"
        bgcolor="#af9b65"
        py={2}
      >
        <Box
          display="flex"
          alignItems="center"
          onClick={handleClose}
          color="white"
          position="absolute"
          left={10}
          top="50%"
          sx={{ transform: "translateY(-50%)" }}
        >
          <KeyboardArrowLeft />
          <Typography fontWeight="bold">戻る</Typography>
        </Box>
        <Typography color="white" variant="h6" fontWeight="bold">
          クチコミ
        </Typography>
      </Box>

      <Box display="flex" flexDirection="column" alignItems="center" px={1}>
        <Typography variant="h4" fontWeight="bold" sx={{ my: 2 }}>
          {storeData.Name}
        </Typography>
        <Box display="flex" alignItems="center">
          <Typography variant="h4" fontWeight="bold" sx={{ mx: 1 }}>
            {storeData.Points.avg.toString()}
          </Typography>
          <Rating size="small" value={storeData.Points.avg} readOnly />
        </Box>
        <Typography variant="body2">{`${storeData.ReviewCount} 件の総合評価`}</Typography>

        <Grid container my={2} mx={1} border={1} py={2} borderColor="divider">
          <Grid
            item
            xs={3}
            display="flex"
            flex={1}
            flexDirection="column"
            alignItems="center"
          >
            <Typography variant="body2">料理・味</Typography>
            <Typography fontWeight="bold">
              {storeData.Points.cooking.toString()}
            </Typography>
          </Grid>

          <Grid
            item
            xs={3}
            display="flex"
            flex={1}
            flexDirection="column"
            alignItems="center"
          >
            <Typography variant="body2">雰囲気</Typography>
            <Typography fontWeight="bold">
              {storeData.Points.atmosphere.toString()}
            </Typography>
          </Grid>

          <Grid
            item
            xs={3}
            display="flex"
            flex={1}
            flexDirection="column"
            alignItems="center"
          >
            <Typography variant="body2">サービス</Typography>
            <Typography fontWeight="bold">
              {storeData.Points.service.toString()}
            </Typography>
          </Grid>

          <Grid
            item
            xs={3}
            display="flex"
            flex={1}
            flexDirection="column"
            alignItems="center"
          >
            <Typography variant="body2">コスパ</Typography>
            <Typography fontWeight="bold">
              {storeData.Points.cost.toString()}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Box px={2} bgcolor="rgb(247 247 247)">
        {reviewList.map((e) => (
          <MReviewCard {...e} />
        ))}
      </Box>
    </Box>
  );
}

export default MReviewSection;
